"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PresetsDropdown = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var PresetsDropdownItem_1 = require("./PresetsDropdownItem");
var positioning_1 = require("../../typings/positioning");
var positioning_2 = require("../../utils/positioning");
var Overlay_1 = require("../../Overlay");
var PresetsDropdown = /** @class */ (function (_super) {
    tslib_1.__extends(PresetsDropdown, _super);
    function PresetsDropdown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PresetsDropdown.prototype.render = function () {
        var _this = this;
        var _a = this.props, presets = _a.presets, anchorEl = _a.anchorEl, onClose = _a.onClose, positioning = _a.positioning;
        return (react_1.default.createElement(Overlay_1.Overlay, { closeOnOutsideClick: true, closeOnParentScroll: true, closeOnMouseDrag: true, alignTo: anchorEl, alignPoints: positioning_2.positioningToAlignPoints(positioning), onClose: onClose },
            react_1.default.createElement("div", { className: "gd-dropdown overlay" },
                react_1.default.createElement("div", { className: "gd-measure-number-format-dropdown-body s-measure-number-format-dropdown-body" },
                    presets.map(function (preset, index) { return _this.renderPresetOption(preset, index); }),
                    this.renderCustomFormatItem()))));
    };
    PresetsDropdown.prototype.renderPresetOption = function (preset, index) {
        var _a = this.props, selectedPreset = _a.selectedPreset, separators = _a.separators, onSelect = _a.onSelect;
        var isPresetItemSelected = selectedPreset && preset.localIdentifier === selectedPreset.localIdentifier;
        return (react_1.default.createElement(PresetsDropdownItem_1.PresetsDropdownItem, { key: preset.localIdentifier + "_" + index, preset: preset, separators: separators, onClick: onSelect, isSelected: isPresetItemSelected }));
    };
    PresetsDropdown.prototype.renderCustomFormatItem = function () {
        var _a = this.props, customPreset = _a.customPreset, presets = _a.presets;
        return this.renderPresetOption(customPreset, presets.length);
    };
    PresetsDropdown.defaultProps = {
        positioning: [
            { snapPoints: { parent: positioning_1.SnapPoint.BottomLeft, child: positioning_1.SnapPoint.TopLeft } },
            { snapPoints: { parent: positioning_1.SnapPoint.TopLeft, child: positioning_1.SnapPoint.BottomLeft } },
        ],
    };
    return PresetsDropdown;
}(react_1.default.PureComponent));
exports.PresetsDropdown = PresetsDropdown;
//# sourceMappingURL=PresetsDropdown.js.map